<template>
    <div>
        <div class="land-ecahrt-title w95mg ">
				 <span class="title fl" @click="chekModel(2)" :class="model == 2?'current':''">Kimi-k2.6专业版</span>
				 <span class="title fl" @click="chekModel(1)" :class="model == 1?'current':''">deepseek-V4专家版</span>
			</div>
        <table border="0" cellspacing="0" cellpadding="0" class="w95mg pagetable1">
            <tr>
                <th class="" style="width: 180px;">行业</th>
                <th>1.行业市场空间</th>
                <th>2.行业发展趋势</th>
                <th>3.企业实力研判</th>
                <th>4.企业竞争力分析</th>
                <th>5.企业风险评价</th>
                <th>6.产业匹配分析</th>
                <th>7.资金政策匹配分析</th>
                <th>综合分析</th>
            </tr>
            <tr v-if="historyList.length==0">
                <td class="">{{ model == 2 ? 'Kimi-k2.6专业版' : 'deepseek-V4专家版' }}</td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(1)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(2)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(3)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(4)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(5)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(6)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(7)">分析 > </td>
                <td class="cur-pointer basefont" @click="hanlderIndustry(8)">分析 > </td>
            </tr>
            <tr v-for="(list,i) in historyList" :key="i">
                <td class="">{{list.notionText}}</td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:1,type:1,list:list}" v-show="list.industryMarketStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:1,type:2,list:list}" v-show="list.industryMarketStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:1,type:3,list:list}" v-show="list.industryMarketStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                   <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:2,type:1,list:list}" v-show="list.industryTrendStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:2,type:2,list:list}" v-show="list.industryTrendStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:2,type:3,list:list}" v-show="list.industryTrendStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:3,type:1,list:list}" v-show="list.companyStrengthStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:3,type:2,list:list}" v-show="list.companyStrengthStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:3,type:3,list:list}" v-show="list.companyStrengthStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:4,type:1,list:list}" v-show="list.companyCompeteStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:4,type:2,list:list}" v-show="list.companyCompeteStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:4,type:3,list:list}" v-show="list.companyCompeteStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                 </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:5,type:1,list:list}" v-show="list.companyRiskStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:5,type:2,list:list}" v-show="list.companyRiskStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:5,type:3,list:list}" v-show="list.companyRiskStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:6,type:1,list:list}" v-show="list.industryMatchStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:6,type:2,list:list}" v-show="list.industryMatchStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:6,type:3,list:list}" v-show="list.industryMatchStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:7,type:1,list:list}" v-show="list.fundingPolicyStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:7,type:2,list:list}" v-show="list.fundingPolicyStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:7,type:3,list:list}" v-show="list.fundingPolicyStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
                <td class="cur-pointer basefont">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link basefont">
                            点击<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="{ModelType:8,type:1,list:list}" v-show="list.comprehensiveStatus>0">查看分析结果 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:8,type:2,list:list}" v-show="list.comprehensiveStatus>0">重新分析 ></el-dropdown-item>
                            <el-dropdown-item :command="{ModelType:8,type:3,list:list}" v-show="list.comprehensiveStatus==0">分析 ></el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </td>
            </tr>
            <tr>
                <td v-if="historyList.length>0" colspan="9" class="cur-pointer basefont" @click="addIndustry()"> + 增加新评估行业 </td>
            </tr>
        </table>
        <el-dialog title="选择行业" :visible.sync="isShowIndustryChoose" width="1380px" top="25vh">
            <dl class="opport-screen bdbe">
                <dt class="fl">推荐行业</dt>
                <dd class="fl">
                    <span :key="index" v-for="(item, index) in Pindustry" @click="notionCode = item.code"
                        :class="notionCode == item.code ? 'a-screen current' : 'a-screen'">{{ item.name }}</span>
                </dd>
            </dl>
            <searchNotionScreen :type="1" :isShowFutureIndustries="true" :isIntegration="true" :notionNumList='[]'
                :showNotionCodeList="{}" :showNotionExtend="true" :token="userdata.token" @chooseNotion="chooseNotion"
                :isShowNotionScreen="true" :isShowOneLevelTotalTag='false'></searchNotionScreen>
            <div class="oh"><el-button class="fr mr-4 mt-3" type="primary" @click="hanlderAimodel(modelType)">确定</el-button></div>
        </el-dialog>
    </div>
</template>

<script>


export default {
    data() {
        return {
            isShowIndustryChoose: false,
            userdata: {},
            notionCode: null,
            model:2,
            modelType: null,
            historyList: [],
        }
    },
    props: {
        baseinfo: {
            type: Object,
            default: () => { }
        },
        Pindustry: {
            type: Array,
            default: () => []
        }
    },
    created() {
        this.userdata = this.getuseriformation();
    },
    mounted() {
        console.log('推荐行业', this.Pindustry);
        this.getHistory();
        
    },

    methods: {
        //选择ai模型
        chekModel(type){
            if(this.model == type){return};
            this.model = type;
            this.getHistory();
        },
        //查看分析结果，去往历史记录页
        handleCommand(command) {
            console.log(command);
            this.modelType = command.ModelType;
            if (command.type == 1) {
               this.routerblank(`/aiChat?id=${command.list.id}&type=history&isEnterprise=true`);
            } else if (command.type == 2) {
                this.hanlderIndustry(this.modelType,command.list,1);
            }else if (command.type == 3) {
                this.hanlderIndustry(this.modelType,command.list,0);
            }
             
        },
        //增加行业
        addIndustry() {
            this.notionCode = null;
            this.isShowIndustryChoose = true;
        },

        /**
         * @description:获取历史记录
         * @return: void
         */
        getHistory() {
            this.historyList = [];
              let ajaxUrl = this.$api.cyl.assessment.history() + '?model='+this.model;
            this.$axios.get(ajaxUrl).then(res => {
                if (res.data.success) {
                    const list = res.data.list || [];
                    for (let i = 0; i < list.length; i++) {
                        if (list[i].stockCode == this.baseinfo.stockCode) {
                            this.historyList.push(list[i]);
                        }
                    }
                    console.log('历史记录', this.historyList);
                }
            }).catch(function (error) { });
        },
        //确定选择行业跳转页面
        hanlderAimodel(type,isUpdate) {
            if(this.notionCode == '' || this.notionCode == null){
                this.$message.warning('请选择行业');
                return;
            }
            this.isShowIndustryChoose = false;
            //存储到本地存储，每次点击覆盖前面的数据
            let aistitle = '';
            switch (type) {
                case 1:
                    aistitle = '行业市场空间分析';
                    break;
                case 2:
                    aistitle = '行业发展趋势分析';
                    break;
                case 3:
                    aistitle = '企业实力研判分析';
                    break;
                case 4:
                    aistitle = '企业竞争力分析';
                    break;
                case 5:
                    aistitle = '企业风险评估';
                    break;
                case 6:
                    aistitle = '产业匹配分析';
                    break;
                case 7:
                    aistitle = '资金政策匹配分析';
                    break;
                case 8:
                    aistitle = '综合分析';
                    break;
            }
            let jsonData = {
                title: this.baseinfo.title + aistitle,
            };
            console.log(jsonData,this.notionCode);
            localStorage.setItem('aiChatData', JSON.stringify(jsonData));
            let isUpdateFlag = this.splicing('update',isUpdate);
            this.routerblank('/aiChat' + '?type=' + type + '&notionCode=' + this.notionCode + '&id=' + this.baseinfo.stockCode + '&model='+this.model + '&industryChat=1'+isUpdateFlag);
        },
        //选择行业
        hanlderIndustry(type,list,updatestatus) {
            this.modelType = type;
            const isUpdate = updatestatus>0?1:0;
            if(list){
                this.notionCode = list.notionCode;
                this.hanlderAimodel(type,isUpdate);
            }else{
                if (this.notionCode == '' || this.notionCode == null) {
                    this.isShowIndustryChoose = true;
                } else {
                    
                    this.hanlderAimodel(this.modelType,isUpdate);
                }

            }
        },
        //概念单选 层级显示
        chooseNotion(chooseNotionlist, notionCode) {
            this.notionCode = notionCode;
        },
    }

}
</script>

<style></style>